import { render, staticRenderFns } from "./DeloadWorkouts.vue?vue&type=template&id=6e2773b8&scoped=true&"
import script from "./DeloadWorkouts.vue?vue&type=script&lang=js&"
export * from "./DeloadWorkouts.vue?vue&type=script&lang=js&"
import style0 from "./DeloadWorkouts.vue?vue&type=style&index=0&id=6e2773b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2773b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VCol,VDivider})
